export const stock = {
  isBoaStock: true,
  stockCode: "",
  quantity: 1,
  location: "",
  price: null,
  stockDescription: "",
  notes: ""
};
